import React from 'react';
import InstallExtensionComponent from '../components/InstallExtension';
import { useExtensionInstalled } from '../contexts/ExtensionInstalled';

const InstallExtension = (): React.ReactElement | null => {
  const { loading, isInstalled } = useExtensionInstalled();

  return !loading && !isInstalled ? <InstallExtensionComponent /> : null;
};

export default InstallExtension;
